/**
 * Notificaciones administrativas · backend real (`/api/notificaciones`).
 * Cache local en `ct_admin_notificaciones_v1` para lecturas síncronas.
 */
import { api } from "@/services/api";
import { isAdminAuthenticated } from "@/data/adminAuthStore";

const KEY = "ct_admin_notificaciones_v1";

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const read = () => {
  if (!isBrowser()) return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const write = (arr) => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* ignore */
  }
};

export const TIPOS_NOTIF = [
  { id: "GENERAL", label: "General" },
  { id: "EVENTO", label: "Evento" },
  { id: "RECORDATORIO", label: "Recordatorio" },
  { id: "CANCELACION", label: "Cancelación" },
  { id: "CAMBIO_SALON", label: "Cambio de salón" },
  { id: "CAMBIO_MESA", label: "Cambio de mesa" },
];

export const DESTINATARIOS = [
  { id: "TODOS", label: "Todos" },
  { id: "ASISTENTES", label: "Solo asistentes" },
  { id: "COMPRADORES", label: "Solo compradores" },
  { id: "PROPIETARIOS", label: "Solo propietarios" },
  { id: "SUSCRIPTORES", label: "Solo suscriptores" },
  { id: "MANUAL", label: "Selección manual" },
];

export const hidratarNotificaciones = async () => {
  if (!isAdminAuthenticated()) return [];
  try {
    const { data } = await api.get("/notificaciones");
    if (Array.isArray(data)) {
      write(data);
      return data;
    }
  } catch {
    /* ignore */
  }
  return read();
};

export const crearNotificacion = async ({ tipo, titulo, mensaje, destinatario }) => {
  if (!titulo || !titulo.trim() || !mensaje || !mensaje.trim()) return null;
  try {
    const { data } = await api.post("/notificaciones", {
      tipo: tipo || "GENERAL",
      titulo: titulo.trim(),
      mensaje: mensaje.trim(),
      destinatario: destinatario || "TODOS",
    });
    // Actualiza cache local optimista.
    const arr = read();
    write([data, ...arr]);
    return data;
  } catch (err) {
    return { error: err?.response?.data?.detail || "network" };
  }
};

export const listarNotificaciones = () =>
  read().slice().sort((a, b) => (a.fechaCreacion < b.fechaCreacion ? 1 : -1));
